import React, { createContext, useEffect, useState, useRef } from "react";
import App from "../../App";
import {
  exitEditMode,
  removeHighlightLayerFromMap,
} from "../../services/MapCore/MapService";
import { HighlightFeatureLayer } from "../../schemes/layers/HighlightFeatureLayer";
const AppContext = createContext({});

export function AppContextProvider() {
  const [layersGroups, setLayersGroups] = useState([]);
  const [isCustomLayerGroupModeActive, setIsCustomLayerGroupModeActive] =
    useState(false);

  const customLayerGroupModeDefaultOptions = {
    onMapClickControl: true, // True - Funcion por defecto, False, deshabilita, función - Override del funcionamiento
    layerIdWithCustomControl: null,
    layerGroupIdWithCustomControl: null,
    customControlMode: null, //"ASBESTOS_CLICK"
  };
  const [customLayerGroupModeOptions, setCustomLayerGroupModeOptions] =
    useState(customLayerGroupModeDefaultOptions);

  const initialModeOptions = {
    ASBESTOS_CLICK: [],
    ADD_POLYGON: [],
    CARBON_SINK: [],
  };
  const [modeOptions, setModeOptions] = useState(initialModeOptions);

  const resetModeOptions = () => {
    exitEditMode({ map: mapInstanceRef.current });
    removeHighlightLayer();
    setModeOptions(initialModeOptions);
  };

  const resetAddPolygon = () => {
    exitEditMode({ map: mapInstanceRef.current });
    removeHighlightLayer();
    setModeOptions((prev) => ({ ...prev, ADD_POLYGON: [] }));
  };

  const enterTeledetecionMode = (layer) => {
    function toggleElement(array, element) {
      const newArray = [...array];
      const index = array.indexOf(element);
      if (index === -1) {
        newArray.push(element); // Si no está, lo agrega
      } else {
        newArray.splice(index, 1); // Si está, lo elimina
      }

      return newArray;
    }

    setIsCustomLayerGroupModeActive((prev) => !prev);
    setCustomLayerGroupModeOptions((prev) => ({
      ...prev,
      onMapClickControl: !customLayerGroupModeOptions.onMapClickControl,
    }));

    setModeOptions((prev) => ({
      ...prev,
      ASBESTOS_CLICK: toggleElement(prev.ASBESTOS_CLICK, layer.id),
    }));
  };

  const exitTeledetecionMode = () => {
    console.log("exitTeledetecionMode");
    setCustomLayerGroupModeOptions((prev) => ({
      ...prev,
      onMapClickControl: !prev.onMapClickControl,
    }));
    setModeOptions((prev) => ({ ...prev, ASBESTOS_CLICK: [] }));

    removeHighlightLayer();
  };

  const removeHighlightLayer = () => {
    setEditedGeometry(null);
    removeHighlightLayerFromMap(mapInstanceRef.current);

    if (!layersGroupsRef.current) {
      console.warn("layersGroupsRef no está inicializado.");
      return;
    }

    const layerId = modeOptions.ASBESTOS_CLICK[0];
    console.log("exitTeledetecionMode layerId", layerId);

    for (const group of layersGroupsRef.current) {
      const layerIndex = group.layers.findIndex(
        (layer) => layer.id === layerId
      );

      if (layerIndex !== -1) {
        console.log(`Capa encontrada:`, group.layers[layerIndex]);
        // group.layers.splice(layerIndex, 1); // Eliminar el layer del array

        // Verificar si hay una capa de tipo HighlightFeatureLayer y eliminarla también
        const highlightLayerIndex = group.layers.findIndex(
          (layer) => layer instanceof HighlightFeatureLayer
        );

        if (highlightLayerIndex !== -1) {
          console.log(
            `Capa de resaltado encontrada y eliminada:`,
            group.layers[highlightLayerIndex]
          );
          group.layers.splice(highlightLayerIndex, 1);
        }

        break; // Termina la iteración ya que solo hay un grupo con la capa
      }
    }
  };

  const enterAddPolygonMode = (layer) => {
    setModeOptions((prev) => ({ ...prev, ADD_POLYGON: [layer.id] }));
  };

  const exitAddPolygonMode = () => {
    setModeOptions((prev) => ({ ...prev, ADD_POLYGON: [] }));
  };

  useEffect(() => {
    setSelectedFeatures([]);
  }, [modeOptions]);

  const [selectedFeatures, setSelectedFeatures] = useState([]);
  useEffect(() => {
    setEditedGeometry(null);
  }, [selectedFeatures]);

  const [dashboardsToShow, setDashboardsToShow] = useState([]);
  const [legendUpdater, setLegendUpdater] = useState(0);
  const updateLegend = () => {
    setLegendUpdater(legendUpdater + 1);
  };
  const layersGroupsRef = useRef(layersGroups);
  const mapElementRef = useRef(0);
  const mapInstanceRef = useRef(0);

  const [map, setMap] = useState(null);
  const [aoiExtent, setAoiExtent] = useState(null);
  const [aoiUuid, setAoiUuid] = useState(null);
  const [generalConfigParams, setGeneralConfigParams] = useState({
    basemap: "google_satellite",
  });
  const [isWindowFeatureDetailsOpen, setIsWindowFeatureDetailsOpen] =
    useState(true);
  const [isWindowLayerDashboardOpen, setIsWindowLayerDashboardOpen] =
    useState(false);
  const [loadingClick, setLoadingClick] = useState(false);
  const [clickCoordinates, setClickCoordinates] = useState([0, 0]);

  const [userProjects, setUserProjects] = useState([]);
  const [project, setProject] = useState();
  // const [project, setProject] = useState({});

  const [openDrawer, setOpenDrawer] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(450); // Ancho inicial

  const [editedGeometry, setEditedGeometry] = useState(null);

  const [carbonResponse, setCarbonResponse] = useState({});
  const [showTutorialCarbonWindow, setShowTutorialCarbonWindow] =
    useState(false);
  const [actualGroundUse, setActualGroundUse] = useState({});

  // TUTORIAL
  const [repeatTutorial, setRepeatTutorial] = useState(false);
  const [anchorElAvatar, setAnchorElAvatar] = useState(null);

  const menuRef = useRef(null);
  const userDirectionRef = useRef(null);
  const mapControlsRef = useRef(null);
  const attributionsRef = useRef(null);
  const myProjectsRef = useRef(null);
  const tabsRef = useRef(null);
  const layersRef = useRef(null);
  const carbonCategoryRef = useRef(null);
  const avatarRef = useRef(null);
  const avatarTutorialButtonRef = useRef(null);

  const [isSelectingProject, setIsSelectingProject] = useState(false);

  const [geoStatus, setGeoStatus] = useState("idle"); // idle | requesting | ready | updating | error

  return (
    <AppContext.Provider
      value={{
        generalConfigParams,
        setGeneralConfigParams,
        layersGroups,
        setLayersGroups,
        selectedFeatures,
        setSelectedFeatures,
        layersGroupsRef,
        map,
        setMap,
        mapElementRef,
        mapInstanceRef,
        isWindowLayerDashboardOpen,
        setIsWindowLayerDashboardOpen,
        dashboardsToShow,
        setDashboardsToShow,
        aoiUuid,
        setAoiUuid,
        updateLegend,
        legendUpdater,
        aoiExtent,
        setAoiExtent,
        isWindowFeatureDetailsOpen,
        setIsWindowFeatureDetailsOpen,
        project,
        setProject,
        loadingClick,
        setLoadingClick,
        clickCoordinates,
        setClickCoordinates,
        isCustomLayerGroupModeActive,
        setIsCustomLayerGroupModeActive,
        customLayerGroupModeOptions,
        setCustomLayerGroupModeOptions,
        userProjects,
        setUserProjects,
        openDrawer,
        setOpenDrawer,
        modeOptions,
        setModeOptions,
        resetModeOptions,
        editedGeometry,
        setEditedGeometry,
        enterTeledetecionMode,
        exitTeledetecionMode,
        removeHighlightLayer,
        enterAddPolygonMode,
        exitAddPolygonMode,
        drawerWidth,
        setDrawerWidth,
        menuRef,
        userDirectionRef,
        mapControlsRef,
        attributionsRef,
        myProjectsRef,
        tabsRef,
        layersRef,
        carbonResponse,
        setCarbonResponse,
        showTutorialCarbonWindow,
        setShowTutorialCarbonWindow,
        actualGroundUse,
        setActualGroundUse,
        repeatTutorial,
        setRepeatTutorial,
        carbonCategoryRef,
        anchorElAvatar,
        setAnchorElAvatar,
        avatarRef,
        avatarTutorialButtonRef,
        isSelectingProject,
        setIsSelectingProject,
        resetAddPolygon,
        geoStatus,
        setGeoStatus,
      }}
    >
      <App />
    </AppContext.Provider>
  );
}

export default AppContext;
